import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {CatalogRecord} from '@store/catalog/catalog.types';
import {CatalogHomeBranchAvailabilityComponent} from '@app/catalog/bib-details/availability/catalog-home-branch-availability.component';
import {CatalogHoldActionsComponent} from '@app/catalog/bib-details/catalog-hold-actions.component';

@Component({
  selector: 'px-catalog-search-availability-column',
  template: `
    <div class="flex flex-col gap-2 text-wrap">
      <px-catalog-home-branch-availability [availability]="catalogRecord.availability" [forTableColumn]="true" class="w-full"/>
      <px-catalog-hold-actions [catalogRecord]="catalogRecord" [forTableColumn]="true" class="w-full"/>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CatalogHoldActionsComponent, CatalogHomeBranchAvailabilityComponent]
})
export class AvailabilityColumnComponent {
  @Input({required: true}) public catalogRecord: CatalogRecord;
}
